import { render, staticRenderFns } from "./ProductSizeDropdown.vue?vue&type=template&id=185ca337&scoped=true"
import script from "./ProductSizeDropdown.vue?vue&type=script&lang=js"
export * from "./ProductSizeDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProductSizeDropdown.vue?vue&type=style&index=0&id=185ca337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ca337",
  null
  
)

export default component.exports